import React from 'react';
import { Row } from '../../data-table';
import { renderCell } from '../../operations/render-cell';
interface RowHeaderDatamodel {
  rowHeader: Row;
}
const RowHeader: React.FC<RowHeaderDatamodel> = ({ rowHeader }) => {
  return (
    <>
      {rowHeader.cells.map((item, colIndex) => {
        const borderStyle = {
          borderTopRightRadius: colIndex === 0 ? '8px' : '',
          borderTopLeftRadius:
            colIndex === rowHeader!.cells.length - 1 ? '8px' : '',
        };
        return (
          <>
            {item.style ? (
              <div className={'grid-row-cell-custom'} style={{ ...item.style }}>
                {renderCell(item)}
              </div>
            ) : (
              <div className={'grid-item-headline'} style={{ ...borderStyle }}>
                <div>{renderCell(item)}</div>
              </div>
            )}
          </>
        );
      })}
    </>
  );
};

export default RowHeader;
